import { Directive, EventEmitter, Output, ElementRef, Input, OnInit, HostListener } from '@angular/core';

import * as ace from 'brace';
// import 'brace/theme/monokai';
// import 'brace/mode/html';

import 'brace/theme/sqlserver';
import 'brace/mode/sql';

@Directive({
    selector: '[aceEditor]'
})
export class AceEditorDirective implements OnInit {

    @Output() textChanged = new EventEmitter();
    @Output() dirty = new EventEmitter();
    @Output() textChange = new EventEmitter();
    _options: any = {};
    _readOnly = false;
    _theme = 'sqlserver';
    _mode: any = 'sql';
    _autoUpdateContent = true;
    _durationBeforeCallback = 0;
    _text = '';
    editor: any;
    oldText: any;
    timeoutSaving: any;
    child;
    @HostListener('window:keydown', ['$event'])
    keyEvent(event: KeyboardEvent) {

        const ctrl = event.ctrlKey;
        const charCode = event.keyCode;

        if (ctrl) {

            if (charCode === 86) {
                this.dirty.emit();
            }
        }
    }

    @HostListener('window:keyup', ['$event'])
        backspaceEvent(event: KeyboardEvent) {
            const ctrl = event.ctrlKey;
            const charCode = event.keyCode;

            if (event.keyCode === 8) {
                this.dirty.emit();
            }

            if (ctrl) {

                if (charCode === 90) {
                    this.dirty.emit();
                }
            }

            return false;

        }


    constructor(elementRef: ElementRef) {
        const el = elementRef.nativeElement;
        this.editor = ace['edit'](el);
        this.editor.$blockScrolling = Infinity;

        const textInput = el.querySelector('.ace_text-input');
        textInput.addEventListener('input', (event) => {
            this.dirty.emit();
        });
    }

    ngOnInit() {
        this.init();
        this.initEvents();
    }



    init() {
        this.editor.setOptions(this._options || {});
        this.editor.setTheme(`ace/theme/${this._theme}`);
        this.setMode(this._mode);
        this.editor.setReadOnly(this._readOnly);

        if (this._options.commands) {
            for (const key in this._options.commands) {
                if (this._options.commands.hasOwnProperty(key)) {
                    const cmd = this._options.commands[key];
                    this.editor.commands.addCommands([{
                        name: key,
                        bindKey: {
                            win: key,
                            mac: key
                        },
                        exec: cmd,
                        readOnly: true
                    }]);
                }
            }
        }

    }

    initEvents() {
        this.editor.on('change', () => this.updateText());
        this.editor.on('paste', () => this.updateText());
    }

    updateText() {
        const newVal = this.editor.getValue(), that = this;

        if (newVal === this.oldText) {
            return;
        }
        if (!this._durationBeforeCallback) {
            this._text = newVal;
            this.textChange.emit(newVal);
            this.textChanged.emit(newVal);
        } else {
            if (this.timeoutSaving != null) {
                clearTimeout(this.timeoutSaving);
            }
            this.timeoutSaving = setTimeout(function () {
                that._text = newVal;
                that.textChange.emit(newVal);
                that.textChanged.emit(newVal);
                that.timeoutSaving = null;
            }, this._durationBeforeCallback);
        }
        this.oldText = newVal;
    }

    @Input() set options(options: any) {
        this._options = options;
        this.editor.setOptions(options || {});
    }

    @Input() set readOnly(readOnly: any) {
        this._readOnly = readOnly;
        this.editor.setReadOnly(readOnly);
    }

    @Input() set theme(theme: any) {
        this._theme = theme;
        this.editor.setTheme(`ace/theme/${theme}`);
    }

    @Input() set mode(mode: any) {
        this.setMode(mode);
    }

    setMode(mode: any) {
        this._mode = mode;
        if (typeof this._mode === 'object') {
            this.editor.getSession().setMode(this._mode);
        } else {
            this.editor.getSession().setMode(`ace/mode/${this._mode}`);
        }
    }

    @Input()
    get text() {
        return this._text;
    }

    set text(text: string) {
        this.setText(text);
    }

    setText(text: any) {
        if (this._text !== text) {
            if (text === null || text === undefined) {
                text = '';
            }

            if (this._autoUpdateContent === true) {
                this._text = text;
                this.editor.setValue(text);
                this.editor.clearSelection();
            }
        }
    }

    @Input() set autoUpdateContent(status: any) {
        this._autoUpdateContent = status;
    }

    @Input() set durationBeforeCallback(num: number) {
        this.setDurationBeforeCallback(num);
    }

    setDurationBeforeCallback(num: number) {
        this._durationBeforeCallback = num;
    }

    get aceEditor() {
        return this.editor;
    }

}
